// Mapping object with Arabic values as keys and their English equivalents as values
import { getCookie } from 'AccountsUtils'

// All trip-related translations
const tripTranslations = {
  'back to trips': 'العودة إلى الرحلات',
  'trip id': 'رقم الرحلة',
  close: 'إغلاق',
  name: 'الاسم',
  sector: 'القطاع',
  pnr: 'رقم الحجز',
  'ticket no.': 'رقم التذكرة',
  'seat no.': 'رقم المقعد',
  status: 'الحالة',
  'baggage (per adult/child)': 'الأمتعة (لكل بالغ/طفل)',
  'view details': 'عرض التفاصيل',
  'airline support': 'دعم شركة الطيران',
  'cleartrip support': 'دعم كليرتريب',
  'for quick assistance, please call from the contact number provided in your booking':
    'للمساعدة السريعة، يرجى الاتصال من رقم الاتصال المقدم في حجزك',
  cabin: 'المقصورة',
  'check-in': 'تسجيل الدخول',
  'fare rules': 'قواعد الأسعار',
  'check-in counter close': 'إغلاق مكتب تسجيل الدخول',
  'transit time': 'وقت العبور',
  'change planes': 'تغيير الطائرات',
  'flight booked with flexifly': 'الرحلة محجوزة مع فليكسيفلاي',
  'save on rescheduling and convenience fees.refund upto ₹3200 per person, per flight for changes made.':
    'وفر على رسوم إعادة الجدولة والرسوم الإضافية. استرداد يصل إلى ₹3200 لكل شخص، لكل رحلة للتغييرات التي تم إجراؤها.',
  'know more': 'اعرف المزيد',
  'traveller details': 'تفاصيل المسافر',
  'cancel flights': 'إلغاء الرحلات',
  'cancel this trip in 3 easy steps': 'إلغاء هذه الرحلة في 3 خطوات سهلة',
  'calculate refund': 'حساب المبلغ المسترد',
  'change flights': 'تغيير الرحلات',
  'reschedule this flight in 4 easy steps':
    'إعادة جدولة هذه الرحلة في 4 خطوات سهلة',
  'know refund before you cancel': 'اعرف المبلغ المسترد قبل الإلغاء',
  'payment details': 'تفاصيل الدفع',
  total: 'المجموع',
  'total paid': 'المبلغ المدفوع',
  'contact details': 'تفاصيل الاتصال',
  email: 'البريد الإلكتروني',
  phone: 'الهاتف',
  'paid via': 'دفع عبر',
  'non refundable': 'غير قابل للاسترداد',
  refundable: 'قابل للاسترداد',
  'trip id missing!!': 'معرف الرحلة مفقود!!',
  'sorry, unable to get your details right now.':
    'عذراً، غير قادر على الحصول على التفاصيل الخاصة بك الآن.',
  "seems there's a temporary issue with our system.":
    'يبدو أن هناك مشكلة مؤقتة في نظامنا.',
  'try again': 'حاول مرة أخرى',
  'loading trip details...': 'جاري تحميل تفاصيل الرحلة...',
  'loading faqs...': 'جاري تحميل الأسئلة الشائعة...',
  'loading contact details...': 'جاري تحميل تفاصيل الاتصال...',

  chat: 'محادثة',
  'contact us': 'اتصل بنا',
  "we'll help you out": 'سنساعدك',
  'print e-ticket': 'طباعة التذكرة الإلكترونية',
  'print ereceipt': 'طباعة الإيصال الإلكتروني',
  'print payment receipt': 'طباعة إيصال الدفع',
  'print voucher': 'طباعة القسيمة',
  'email pass': 'إرسال التصريح عبر البريد الإلكتروني',
  'email voucher': 'إرسال القسيمة عبر البريد الإلكتروني',
  'email itinerary': 'إرسال خط السير عبر البريد الإلكتروني',
  'sms trip details': 'إرسال تفاصيل الرحلة عبر الرسائل القصيرة',
  'your travel bookings': 'حجوزات سفرك',
  'print tax invoice': 'طباعة فاتورة الضريبة',

  'traveller details': 'تفاصيل المسافر',
  traveller: 'المسافر',
  'trip tools': 'أدوات الرحلة',

  'payment details': 'تفاصيل الدفع',
  'fetching trips': 'جاري جلب الرحلات',
  'please wait while we load your trips.':
    'يرجى الانتظار بينما نقوم بتحميل رحلاتك.',
  cancel: 'إلغاء',
  'check refund': 'التحقق من المبلغ المسترد',
  'change flights': 'تغيير الرحلات',
  'add to passbook': 'إضافة إلى المحفظة',
  'email trip': 'إرسال الرحلة عبر البريد الإلكتروني',
  'cancel this trip in 3 easy steps': 'إلغاء هذه الرحلة في 3 خطوات سهلة',
  'know your refund before cancellation': 'اعرف المبلغ المسترد قبل الإلغاء',
  'change flights in 4 simple steps': 'تغيير الرحلات في 4 خطوات بسيطة',
  'save the planet. go paperless.': 'حافظ على الكوكب. استغنِ عن الورق.',
  'share your trip easily': 'شارك رحلتك بسهولة',
  'sorry, unable to fetch your trips right now.':
    'عذراً، غير قادر على جلب رحلاتك الآن.',
  'your bookings appear here': 'تظهر حجوزاتك هنا',
  'see all bookings': 'عرض جميع الحجوزات',
  'load more': 'تحميل المزيد',

  venue: 'المكان',
  'booking details': 'تفاصيل الحجز',
  'booking information': 'معلومات الحجز',
  'organiser details': 'تفاصيل المنظم',
  'voucher # ': 'رقم القسيمة # ',
  address: 'العنوان',
  'baggage (per person)': 'الأمتعة (لكل شخص)',

  'free checkin-baggage allowance is 20 kg per adult & child. if travelling ex-india to muscat / colombo / dubai / kabul / honkong / jeddah, free check-in baggage allowance is 30 kgs. if travelling ex-muscat / ex-colobmo / ex-dubai / ex-kabul / ex-hongkong free check-in baggage allowance is 30 kg per adult. if travelling ex-jeddah free check-in baggage allowance is 30kgs + 5lt. each bag must not exceed 32 kg and overall dimensions of checked baggage should not exceed 62 inches.':
    'مسموح الحقائب المجانية 20 كجم لكل بالغ وطفل. إذا كنت مسافراً من الهند إلى مسقط / كولومبو / دبي / كابول / هونج كونج / جدة، فمسموح الحقائب المجانية 30 كجم. إذا كنت مسافراً من مسقط / كولومبو / دبي / كابول / هونج كونج، فمسموح الحقائب المجانية 30 كجم لكل بالغ. إذا كنت مسافراً من جدة، فمسموح الحقائب المجانية 30 كجم + 5 لتر. يجب ألا تتجاوز كل حقيبة 32 كجم والأبعاد الكلية للحقائب المسجلة يجب ألا تتجاوز 62 بوصة.',
  'got it': 'فهمت',

  send: 'إرسال',
  'please enter email id': 'الرجاء إدخال معرف البريد الإلكتروني',
  'email sent successfully': 'تم إرسال البريد الإلكتروني بنجاح',
  'email cannot be sent currently. please try in some time':
    'لا يمكن إرسال البريد الإلكتروني حالياً. يرجى المحاولة بعد قليل',
  'email address is not valid': 'عنوان البريد الإلكتروني غير صالح',

  terminal: 'المحطة',

  'the details for the trip cannot be fetched at the moment. please call our customer care for any information.':
    'لا يمكن جلب تفاصيل الرحلة في الوقت الحالي. يرجى الاتصال بخدمة العملاء للحصول على أي معلومات.',
  '**convenience fee of 0.0 per passenger paid during booking is non-refundable as it is used towards "payment gateway" charges. this helps us run cleartrip.':
    '**رسوم التسهيل البالغة 0.0 لكل مسافر المدفوعة أثناء الحجز غير قابلة للاسترداد حيث يتم استخدامها في رسوم "بوابة الدفع". هذا يساعدنا في تشغيل كليرتريب.',
  'email e-ticket': 'إرسال التذكرة الإلكترونية عبر البريد الإلكتروني',
  'email gst invoice': 'إرسال فاتورة ضريبة السلع والخدمات عبر البريد الإلكتروني'
}

// Wallet-related translations
const walletTranslations = {
  'domain balances': 'أرصدة النطاقات',
  currency: 'العملة',
  balance: 'الرصيد',
  'these are your corresponding wallet balances in different domains. do a booking from that domain to access that in bookings.':
    'هذه هي أرصدتك المقابلة في محفظتك في النطاقات المختلفة. قم بالحجز من ذلك النطاق للوصول إليه في الحجوزات.',
  trips: 'الرحلات',
  'my bookings': 'حجوزاتي',
  travellers: 'المسافرين',
  wallet: 'المحفظة',
  profile: 'الملف الشخصي',
  settings: 'الإعدادات',
  expressway: 'الخروج',
  support: 'الدعم',
  reschedule: 'إعادة الجدولة',
  refund: 'استرداد',
  earned: 'المكتوب',
  used: 'المستخدم',
  'my wallet balance': 'رصيد محفظة المحفظة',
  flights: 'الطيران',
  hotels: 'الفنادق',
  vouchers: 'الأوكورات',
  payments: 'المدفوعات',
  'flight + hotel': 'طيران + فنادق',
  'transaction id:': 'معرف المعاملة:',
  date: 'التاريخ',
  'flyin cash': 'نقداً',
  'expire on:': 'انتهاء في:',
  "you don't have any transactions": 'ليس لديك أي معاملات',
  source: 'المصدر',
  'transaction id': 'معرف المعاملة',
  'transaction type': 'نوع المعاملة',
  amount: 'المبلغ',
  'expiry date': 'تاريخ انتهاء الصلاحية',
  'load more transactions': 'تحميل المزيد من المعاملات',
  back: 'رجوع',
  'congratulations! you saved': 'تهانينا! لقد وفرت',
  with: 'مع',
  "it assists, it enables, it empowers, it upgrades. it's your advantage.":
    'يساعد ويمكن ويعزز ويرتقي. إنها ميزتك.',
  'it assists, it enables, it empowers, it upgrades.':
    'يساعد ويمكن ويعزز ويرتقي.',
  "it's your advantage.": 'إنها ميزتك.',
  'ct advantage': 'ميزة CT',
  'hang on': 'انتظر',
  'medi-cancel banner': 'لافتة إلغاء طبي',
  'medi-cancel': 'إلغاء طبي',
  actions: 'إجراءات',
  'fetching trip details': 'جاري جلب تفاصيل الرحلة',
  'please wait while we load your trip details.':
    'يرجى الانتظار بينما نقوم بتحميل تفاصيل رحلتك.',
  'sorry unable to get your information now.':
    'عذرًا، غير قادر على الحصول على معلوماتك الآن.',
  'all trips': 'جميع الرحلات',
  'completed trips': 'الرحلات المكتملة',
  'fetching trips...': 'جاري جلب الرحلات...',
  'load more trips...': 'تحميل المزيد من الرحلات...',
  'looks like you have not booked any trips yet.':
    'يبدو أنك لم تحجز أي رحلات بعد.',
  'start exploring!': 'ابدأ الاستكشاف!',
  'collections empty': 'مجموعات فارغة',
  'loading trips...': 'جاري تحميل الرحلات...',
  'logged in successfully!': 'تم تسجيل الدخول بنجاح!',
  'wallet cashback': 'استرداد نقدي للمحفظة',
  adjustments: 'تعديلات',
  'refund to wallet': 'استرداد إلى المحفظة'
}

const noticeBannerTranslations = {
  to: 'إلى',
  and: 'و',
  'flight for': 'رحلة لـ',
  'open ticket/credit shell': 'تذكرة مفتوحة/قسيمة ائتمانية',
  'change flight': 'تغيير الرحلة',
  'cancel flight': 'إلغاء الرحلة',
  'click here': 'انقر هنا',
  'to see all airline policies.': 'لمشاهدة جميع سياسات شركات الطيران.',
  'to know how to claim a refund or reschedule your flight(s)':
    'لمعرفة كيفية المطالبة باسترداد أو إعادة جدولة رحلتك (رحلاتك)',
  'airline info': 'معلومات شركة الطيران',
  'please call the airline at': 'يرجى الاتصال بشركة الطيران على',
  'to refund or reschedule your flight': 'لاسترداد أو إعادة جدولة رحلتك',
  "you can convert your $$replace$$ trip to an open ticket/credit shell. you won't get any refund now, but you can come back and amend this booking to a different date later.":
    'يمكنك تحويل رحلتك $$replace$$ إلى تذكرة مفتوحة/قسيمة ائتمانية. لن تحصل على أي استرداد الآن، ولكن يمكنك العودة وتعديل هذا الحجز إلى تاريخ آخر لاحقًا.',
  'your $$replace$$ flight is/are eligible for a free cancellation/flight change due to coronavirus. fare difference applicable for flight changes.':
    'رحلتك $$replace$$ مؤهلة للإلغاء المجاني/تغيير الرحلة بسبب فيروس كورونا. فرق السعر ينطبق على تغييرات الرحلة.',
  'your $$replace$$ flight is/are eligible for a free cancellation due to coronavirus.':
    'رحلتك $$replace$$ مؤهلة للإلغاء المجاني بسبب فيروس كورونا.',
  'your $$replace$$ flight is/are eligible for flight change due to coronavirus. fare difference applicable for flight changes.':
    'رحلتك $$replace$$ مؤهلة لتغيير الرحلة بسبب فيروس كورونا. فرق السعر ينطبق على تغييرات الرحلة.',
  'all or few sectors in your trip are eligible for credit shell from the airline due to coronavirus pandemic.':
    'جميع أو بعض القطاعات في رحلتك مؤهلة للحصول على قسيمة ائتمانية من شركة الطيران بسبب جائحة فيروس كورونا.',
  'your trip is eligible for credit shell from the airline due to coronavirus pandemic.':
    'رحلتك مؤهلة للحصول على قسيمة ائتمانية من شركة الطيران بسبب جائحة فيروس كورونا.',
  'your $$replace$$ has been converted into an open ticket/credit shell. as per the airline policy, there is no refund applicable for this booking and they have offered to adjust the entire amount in your next booking for the same passenger. to rebook your open ticket or utilise credit shell, kindly click on "contact us" and select the "rebook open ticket or utilise credit shell" option.':
    'تم تحويل $$replace$$ إلى تذكرة مفتوحة/قسيمة ائتمانية. وفقًا لسياسة شركة الطيران، لا يوجد استرداد ينطبق على هذا الحجز وقد عرضوا تعديل المبلغ بالكامل في حجزك التالي لنفس المسافر. لإعادة حجز تذكرتك المفتوحة أو استخدام القسيمة الائتمانية، يرجى النقر على "اتصل بنا" واختيار خيار "إعادة حجز تذكرة مفتوحة أو استخدام قسيمة ائتمانية".',
  'spice jet has auto cancelled all bookings and have converted them into credit shell/voucher (of the entire booking amount) and you will need to contact spice jet call center post 1st april 2020 until 21st feb 2021 to redeem the credit towards this booking for the new booking of your choice. (fare difference if any will have to be paid at the time of making a new booking)':
    'قامت سبايس جيت بإلغاء جميع الحجوزات تلقائياً وتحويلها إلى قسيمة ائتمانية/قسيمة (بكامل مبلغ الحجز) وستحتاج إلى الاتصال بمركز اتصال سبايس جيت بعد 1 أبريل 2020 حتى 21 فبراير 2021 لاسترداد الرصيد نحو هذا الحجز للحجز الجديد من اختيارك. (سيتعين دفع فرق السعر إن وجد في وقت إجراء حجز جديد)',
  'to rebook a new ticket with credit shell. 1. please click on "contact us" 2. click rebook & an cleartripper will get back to you.':
    'لإعادة حجز تذكرة جديدة باستخدام القسيمة الائتمانية. 1. يرجى النقر على "اتصل بنا" 2. انقر على إعادة الحجز وسيتواصل معك أحد موظفي كليرتريب.',
  'go air is not allowing any refunds against cancellations at this point and you can call go air call center up to 30th september 2020 and make a new booking using the same amount of this ticket (fare difference if any will have to be paid at the time of making a new booking)':
    'لا تسمح جو إير بأي استردادات مقابل الإلغاءات في هذه المرحلة ويمكنك الاتصال بمركز اتصال جو إير حتى 30 سبتمبر 2020 وإجراء حجز جديد باستخدام نفس مبلغ هذه التذكرة (سيتعين دفع فرق السعر إن وجد في وقت إجراء حجز جديد)'
}

const paymentContainerTranslations = {
  on: 'في',
  at: 'في',
  hrs: 'ساعة',
  and: 'و',
  to: 'إلى',
  adult: 'بالغ',
  child: 'طفل',
  infant: 'رضيع',
  'refund amount': 'مبلغ الاسترداد',
  'payment details': 'تفاصيل الدفع',
  total: 'المجموع',
  'paid via': 'دفع عبر',
  coins: 'عملات',
  'amend payment details': 'تفاصيل دفع التعديل',
  'refunded to': 'تم استرداده إلى',
  'medi-cancel benefit': 'فائدة الإلغاء الطبي',
  free: 'مجاناً',
  'refund details': 'تفاصيل الاسترداد',
  refunded: 'تم استرداده',
  'additional refund details': 'تفاصيل استرداد إضافية',
  'arn no': 'رقم المرجع',
  for: 'لـ',
  'booked for': 'تم الحجز لـ',
  'flight for': 'رحلة لـ'
}

const supportContainerTranslations = {
  'trip support': 'دعم الرحلة',
  'we are here to help': 'نحن هنا للمساعدة',
  'need assistance': 'بحاجة إلى مساعدة',
  'raise a support request': 'تقديم طلب دعم',
  'your support requests': 'طلبات الدعم الخاصة بك',
  'view all support request(s)': 'عرض جميع طلبات الدعم',
  view: 'عرض',
  'active request(s)': 'طلب(ات) نشط',
  'no active support request(s)': 'لا توجد طلبات دعم نشطة',
  'contact us': 'اتصل بنا',
  'back to top': 'العودة إلى الأعلى'
}

const trackerContainerTranslations = {
  'booking status': 'حالة الحجز',
  'refund status': 'حالة استرداد الأموال',
  'refund of': 'استرداد قيمة',
  'view breakup': 'عرض التفاصيل',
  'refund will be processed to your': 'سيتم معالجة المبلغ المسترد إلى',
  'cleartrip wallet': 'محفظة كليرتريب',
  'upi id': 'معرف UPI'
}

// TravellerContainer translations
const travellerContainerTranslations = {
  'traveller details': 'تفاصيل المسافر',
  'ticket no.': 'رقم التذكرة',
  'passport no.': 'رقم جواز السفر',
  dob: 'تاريخ الميلاد',
  'traveller name': 'اسم المسافر',
  'age group': 'الفئة العمرية',
  'date of birth': 'تاريخ الميلاد',
  nationality: 'الجنسية',
  'passport number': 'رقم جواز السفر',
  'ticket number': 'رقم التذكرة',
  status: 'الحالة',
  adult: 'بالغ',
  child: 'طفل',
  infant: 'رضيع',
  // Common booking statuses
  confirmed: 'مؤكد',
  cancelled: 'ملغى',
  refunded: 'مسترد',
  'payment failed': 'فشل الدفع',
  pending: 'قيد الانتظار',
  expired: 'منتهى الصلاحية'
}

const activityTripDetailsTranslations = {
  back: 'رجوع',
  'trip id': 'رقم الرحلة',
  'booked by': 'تم الحجز بواسطة',
  on: 'في',
  at: 'في',
  'cancel activity': 'إلغاء النشاط',
  'this activity can be cancelled using the cleartrip app':
    'يمكن إلغاء هذا النشاط باستخدام تطبيق كليرتريب',
  'start time': 'وقت البدء',
  hours: 'ساعات',
  'booking details': 'تفاصيل الحجز',
  'activity type': 'نوع النشاط',
  'entry for': 'دخول لـ',
  'voucher no': 'رقم القسيمة',
  status: 'الحالة',
  variant: 'النوع',
  unit: 'وحدة',
  'persons/unit': 'أشخاص/وحدة',
  adult: 'بالغ',
  s: 'ين', // Plural suffix for Adult
  child: 'طفل',
  ren: 'أطفال', // Plural suffix for Child
  inclusions: 'المشمولات',
  'payment details': 'تفاصيل الدفع',
  'cost of experience': 'تكلفة التجربة',
  'inclusive of gst/taxes': 'شاملة ضريبة السلع والخدمات/الضرائب',
  'other charges': 'رسوم أخرى',
  'convenience fee': 'رسوم التسهيل',
  discount: 'خصم',
  total: 'المجموع',
  'paid via': 'دفع عبر',
  'contact details': 'تفاصيل الاتصال',
  name: 'الاسم',
  phone: 'الهاتف',
  email: 'البريد الإلكتروني'
}

// JSON response translations
const jsonResponseTranslations = {
  air: 'الطيران',
  upcoming: 'قادم',
  'one-way': 'ذهاب فقط',
  false: 'خطأ',
  confirmed: 'مؤكد',
  standard: 'قياسي',
  'base fare': 'السعر الأساسي',
  insurance: 'التأمين',
  'cashback (-)': 'استرداد نقدي (-)',
  'discount (-)': 'خصم (-)',
  meals: 'وجبات',
  'additional baggages': 'أمتعة إضافية',
  seats: 'مقاعد',
  'taxes and fees': 'الضرائب والرسوم',
  'amendment charges': 'رسوم التعديل',
  'credit card': 'بطاقة ائتمان',
  'is flying': 'مسافر',
  international: 'دولي',
  'unable to fetch baggage details. contact airline or visit airline website.':
    'غير قادر على جلب تفاصيل الأمتعة. اتصل بشركة الطيران أو قم بزيارة موقع شركة الطيران.',
  'minutes prior to departure': 'دقائق قبل المغادرة',
  booked: 'محجوز',
  'real time': 'الوقت الفعلي',
  adult: 'بالغ',
  'click here': 'انقر هنا',
  'long layover': 'الحجز الطويل',
  'short layover': 'الحجز القصير',
  'gst (airline)': 'ض.س.خ (شركة الطيران)'
}

const htmlSnippetsTranslations = {
  'booking confirmed': 'تم تأكيد الحجز',
  'payment initiated': 'تم بدء الدفع',
  'payment complete': 'اكتمل الدفع',
  'awaiting pnr': 'في انتظار رقم الحجز',
  'estimated time': 'الوقت المقدر',
  'e-ticket': 'التذكرة الإلكترونية',
  'we have received your payment. it is taking longer than usual. the pnr(s) will reach us within the next 2 hours. your booking remains confirmed, and you will receive the e-ticket soon.':
    'لقد استلمنا دفعتك. يستغرق الأمر وقتًا أطول من المعتاد. سيصلنا رقم الحجز خلال الساعتين القادمتين. يظل حجزك مؤكدًا، وستتلقى التذكرة الإلكترونية قريبًا.',
  terminal: 'محطة',
  'check-in counter closes': 'يغلق مكتب تسجيل الدخول',
  'minutes prior to departure': 'دقائق قبل المغادرة',
  'flight tracker': 'متتبع الرحلة',
  'fare type': 'نوع التعريفة',
  'baggage details': 'تفاصيل الأمتعة',
  'upcoming trips': 'الرحلات القادمة',
  'cancelled and payment failed trips': 'الرحلات الملغاة والتي فشل الدفع فيها'
}

const baggageComponentTranslations = {
  'baggage rules': 'قواعد الأمتعة',
  'for adult/child': 'للبالغين/الأطفال',
  'for infant': 'للرضع',
  note: 'ملاحظة',
  'baggage details': 'تفاصيل الأمتعة',
  adult: 'بالغ',
  infant: 'رضيع',
  'extra baggage': 'أمتعة إضافية'
}

// Footer translations with lowercase keys
const footerTranslations = {
  'about us': 'من نحن',
  faq: 'الأسئلة المتكررة',
  'contact us': 'اتصل بنا',
  'flyin wallet': 'محفظة فلاي إن',
  'flyin franchise': 'امتياز فلاي إن',
  'add your property': 'أضف عقارك',
  careers: 'الوظائف',
  'google play': 'جوجل بلاي',
  'app store': 'آب ستور',
  'vat certificate': 'شهادة ضريبة القيمة المضافة',
  'subscribe to our new offers': 'اشترك في عروضنا الجديدة',
  'browse hotels by country': 'تصفح الفنادق حسب البلد',
  'flight & hotels in one place': 'الطيران والفنادق في مكان واحد',
  "download our app now! just a few clicks and you're done!":
    'حمّل تطبيقنا الآن! بضع نقرات فقط وستنتهي!',
  'privacy policy': 'سياسة الخصوصية',
  'terms of use': 'شروط الاستخدام',
  'file a claim': 'تقديم مطالبة',
  paypal: 'باي بال',
  'saudi ebreez company': 'شركة إبريز السعودية'
}

// ToolList translations with lowercase keys
const toolListTranslations = {
  cancel: 'إلغاء',
  'cancel flights': 'إلغاء الرحلات',
  'check refund': 'التحقق من المبلغ المسترد',
  'calculate refund': 'حساب المبلغ المسترد',
  reschedule: 'إعادة الجدولة',
  'reschedule flights': 'إعادة جدولة الرحلات',
  'e-ticket': 'التذكرة الإلكترونية',
  'download ticket': 'تحميل التذكرة',
  'download invoice': 'تحميل الفاتورة',
  'know more': 'اعرف المزيد',

  // VAS (Value Added Services) messages
  'flight booked with flexifly. save on rescheduling fee.':
    'الرحلة محجوزة مع فليكسيفلاي. وفر على رسوم إعادة الجدولة.',
  'flight booked with freedom fare. cancel trip without charges.':
    'الرحلة محجوزة بتعريفة الحرية. إلغاء الرحلة بدون رسوم.',
  'trip booked with ezcancel. for such bookings, get a full refund on cancellation up to 72 hours before the trip.':
    'الرحلة محجوزة مع إيزي كانسل. لمثل هذه الحجوزات، احصل على استرداد كامل عند الإلغاء حتى 72 ساعة قبل الرحلة.',
  'flight booked with ezcancel. get a guaranteed refund on cancellation.':
    'الرحلة محجوزة مع إيزي كانسل. احصل على استرداد مضمون عند الإلغاء.'
}

const actionsContainerTranslations = {
  email: 'البريد الإلكتروني',
  download: 'تحميل',
  invoice: 'الفاتورة',
  ereceipt: 'الإيصال الإلكتروني',
  'web check in': 'تسجيل الدخول عبر الإنترنت',
  'select flight for check-in': 'اختر رحلة لتسجيل الدخول',
  'you will be redirected to the airline website.':
    'سيتم إعادة توجيهك إلى موقع شركة الطيران.',
  'flight logo': 'شعار شركة الطيران',
  'more trip tools': 'المزيد من أدوات الرحلة'
}

const baggageItemTranslations = {
  'per adult': 'لكل بالغ',
  'per infant': 'لكل رضيع',
  'check-in': 'تسجيل الدخول',
  cabin: 'المقصورة',
  baggage: 'الأمتعة',
  'view details': 'عرض التفاصيل',
  'info. not available': 'المعلومات غير متوفرة',
  'learn more': 'اعرف المزيد',
  'read more': 'قراءة المزيد',
  infant: 'رضيع'
}

const segmentContainerTranslations = {
  'added meals': 'الوجبات المضافة',
  'meal preferences': 'تفضيلات الوجبات',
  insurance: 'التأمين',
  'insurance detail': 'تفاصيل التأمين',
  seats: 'المقاعد',
  'seat preferences': 'تفضيلات المقاعد',
  'extra baggage': 'الأمتعة الإضافية',
  'additional baggage': 'الأمتعة الإضافية',
  'fare type': 'نوع التعريفة',
  'additional benefits': 'المزايا الإضافية',
  benefits: 'مزايا',
  'flight status': 'حالة الرحلة',
  'track flight': 'تتبع الرحلة',
  'info. not available': 'المعلومات غير متوفرة',
  'learn more': 'معرفة المزيد',
  'flyin cash': 'رصيد فلاي إن',
  'flights and hotel': 'الرحلات والفنادق',
  'qitaf top-up': 'إضافة رصيد قطاف',
  qitaf: 'قطاف',
  gift: 'هدية',
  flight: 'رحلة طيران',
  hotel: 'فندق',
  'deducted by agent': 'تم خصمه بواسطة الوكيل',
  'booking(amount reversed)': 'الحجز (المبلغ المسترد)',
  booking: 'الحجز',
  cashback: 'استرداد نقدي'
}

const dateTranslations = {
  // Months (full names)
  january: 'يناير',
  february: 'فبراير',
  march: 'مارس',
  april: 'أبريل',
  may: 'مايو',
  june: 'يونيو',
  july: 'يوليو',
  august: 'أغسطس',
  september: 'سبتمبر',
  october: 'أكتوبر',
  november: 'نوفمبر',
  december: 'ديسمبر',

  // Months (short forms)
  jan: 'يناير',
  feb: 'فبراير',
  mar: 'مارس',
  apr: 'أبريل',
  may: 'مايو',
  jun: 'يونيو',
  jul: 'يوليو',
  aug: 'أغسطس',
  sep: 'سبتمبر',
  oct: 'أكتوبر',
  nov: 'نوفمبر',
  dec: 'ديسمبر',

  // Days of the week (full names)
  sunday: 'الأحد',
  monday: 'الاثنين',
  tuesday: 'الثلاثاء',
  wednesday: 'الأربعاء',
  thursday: 'الخميس',
  friday: 'الجمعة',
  saturday: 'السبت',

  // Days of the week (short forms)
  sun: 'الأحد',
  mon: 'الاثنين',
  tue: 'الثلاثاء',
  wed: 'الأربعاء',
  thu: 'الخميس',
  fri: 'الجمعة',
  sat: 'السبت'
}

// Qitaf-related translations to add to the translation mapping
const qitafTranslations = {
  // Tab and section headings
  'top up with qitaf': 'إضافة رصيد بنقاط قطاف',
  'add money to your wallet using qitaf points':
    'أضف المال إلى محفظتك باستخدام نقاط قطاف',
  'top-up your flyin wallet using qitaf points which will never expire with us. qitaf points moved to wallet cannot be refunded but can be used for flyin bookings.':
    'أضف رصيداً إلى محفظة فلاي إن باستخدام نقاط قطاف التي لن تنتهي صلاحيتها معنا. لا يمكن استرداد نقاط قطاف المحولة إلى المحفظة ولكن يمكن استخدامها في حجوزات فلاي إن.',

  // Form labels and placeholders
  'enter your stc mobile number': 'أدخل رقم جوال stc الخاص بك',
  'e.g. 555240680': 'مثال: 555240680',
  'enter otp received on': 'أدخل رمز التحقق المستلم على',
  'enter otp': 'أدخل رمز التحقق',
  'enter amount to redeem': 'أدخل المبلغ المراد استبداله',
  'enter amount': 'أدخل المبلغ',

  // Button texts
  'sending...': 'جارِ الإرسال...',
  'generate otp': 'إنشاء رمز التحقق',
  'processing...': 'جارِ المعالجة...',
  redeem: 'استبدال',
  back: 'رجوع',
  'resending...': 'جارِ إعادة الإرسال...',
  'resend otp': 'إعادة إرسال رمز التحقق',

  // Error and success messages
  'mobile number is required': 'رقم الجوال مطلوب',
  'mobile number must start with 55 and have 9 digits':
    'يجب أن يبدأ رقم الجوال بـ 55 ويتكون من 9 أرقام',
  'otp is required': 'رمز التحقق مطلوب',
  'amount is required': 'المبلغ مطلوب',
  'please enter a valid amount': 'الرجاء إدخال مبلغ صحيح',
  'otp has been sent to your mobile number':
    'تم إرسال رمز التحقق إلى رقم جوالك',
  'failed to send otp. please try again.':
    'فشل في إرسال رمز التحقق. الرجاء المحاولة مرة أخرى.',
  'qitaf points redeemed successfully!': 'تم استبدال نقاط قطاف بنجاح!',
  'failed to redeem qitaf points. please try again.':
    'فشل في استبدال نقاط قطاف. الرجاء المحاولة مرة أخرى.',
  'unable to fetch wallet details! please try again.':
    'تعذر جلب تفاصيل المحفظة! الرجاء المحاولة مرة أخرى.',
  'unable to fetch transactions! please try again.':
    'تعذر جلب المعاملات! الرجاء المحاولة مرة أخرى.',
  'error sending otp:': 'خطأ في إرسال رمز التحقق:',

  // Other labels
  id: 'المعرف',
  'loading...': 'جارِ التحميل...',
  'expiry on': 'تاريخ الانتهاء في',

  // Additional translation
  'enter your qitaf registered mobile number above and click on generate otp. you will receive an sms code required to complete your payment.':
    'أدخل رقم جوال قطاف المسجل أعلاه واضغط على إنشاء رمز التحقق. ستتلقى رمزاً عبر الرسائل القصيرة مطلوباً لإتمام عملية الدفع.'
}

// Cancellation block modal - temporary block for cancellation flow
const cancellationBlockModalTranslations = {
  'for cancellation please contact our customer support':
    'للإلغاء يرجى التواصل مع خدمة العملاء',
  'For cancellation please contact our customer support':
    'للإلغاء يرجى التواصل مع خدمة العملاء',
  'For Calls From Saudi Arabia': 'للمكالمات من المملكة العربية السعودية',
  'For International calls & Whatsapp': 'للمكالمات الدولية وواتساب',
  'For any general inquiries': 'لأي استفسارات عامة',
  'Cancellation support': 'دعم الإلغاء',
  'cancellation support': 'دعم الإلغاء',
  'Customer Care No': 'رقم خدمة العملاء',
  'customer care no': 'رقم خدمة العملاء',
  'WhatsApp support number': 'رقم واتساب للدعم',
  'whatsapp support number': 'رقم واتساب للدعم'
}

// Cancellation step-2 "Cancel now" confirmation modal
const cancellationConfirmModalTranslations = {
  'confirm cancellation': 'تأكيد الإلغاء',
  'are you sure you want to cancel this booking?': 'هل أنت متأكد أنك تريد إلغاء هذا الحجز؟',
  'sure, cancel now': 'نعم، قم بالإلغاء الآن'
}

// Cancellation refund breakup labels
const cancellationRefundBreakupTranslations = {
  'cleartrip cancellation fee ': 'رسوم إلغاء فلاين',
  'cleartrip cancellation fee': 'رسوم إلغاء فلاين',
  'flyin cancellation fee ': 'رسوم إلغاء فلاين',
  'flyin cancellation fee': 'رسوم إلغاء فلاين'
}

// Combine all translations into a single mapping object
const mapping = {
  ...tripTranslations,
  ...walletTranslations,
  ...noticeBannerTranslations,
  ...paymentContainerTranslations,
  ...supportContainerTranslations,
  ...trackerContainerTranslations,
  ...travellerContainerTranslations,
  ...activityTripDetailsTranslations,
  ...jsonResponseTranslations,
  ...htmlSnippetsTranslations,
  ...baggageComponentTranslations,
  ...footerTranslations,
  ...toolListTranslations,
  ...segmentContainerTranslations,
  ...actionsContainerTranslations,
  ...baggageItemTranslations,
  ...dateTranslations,
  ...qitafTranslations,
  ...cancellationBlockModalTranslations,
  ...cancellationConfirmModalTranslations,
  ...cancellationRefundBreakupTranslations
}

export function getMappedValue(inputText) {
  if (!inputText) return inputText

  const lowerCaseInput =
    typeof inputText === 'string' ? inputText.toLowerCase() : ''

  return getCookie('selectedLanguage') == 'ar' ?
    mapping[lowerCaseInput] || inputText :
    inputText
}
